import { Route, Routes } from 'react-router-dom'

import Details from './screens/Details'
import Integrations from './screens/Integrations'
import Relations from './screens/Relations'
import SalesforceDetails from './screens/SalesforceDetails'

const AgencyEditRoutes = () => (
  <Routes>
    <Route index element={<Details />} />
    <Route path="/integrations" element={<Integrations />} />
    <Route path="/relations" element={<Relations />} />
    <Route path="/salesforceDetails" element={<SalesforceDetails />} />
  </Routes>
)

export default AgencyEditRoutes
